import { useMemo } from 'react'
import { useGetDivisionsOnMount } from '@user/store/divisions/hooks'
import { useGetUserListOnMount } from '@user/store/users'
import { useGetServicesForTenantOnMount } from '@user/store/serviceProducts/hooks/useGetServicesOnMount'
import { useGetServiceFrequenciesOnMount } from '@user/store/serviceFrequency/hooks/useGetServiceFrequenciesOnMount'

export function useImportData() {
  const divisionStatus = useGetDivisionsOnMount()
  const ownersStatus = useGetUserListOnMount()
  const servicesStatus = useGetServicesForTenantOnMount()
  const serviceFreqStatus = useGetServiceFrequenciesOnMount()

  const statuses = [
    divisionStatus,
    ownersStatus,
    servicesStatus,
    serviceFreqStatus,
  ]

  const loading = useMemo(
    () => statuses.some((status) => status === 'pending'),
    [statuses],
  )
  const success = useMemo(
    () => statuses.every((status) => status === 'success'),
    [statuses],
  )
  const fail = useMemo(
    () => statuses.some((status) => status === 'fail'),
    [statuses],
  )

  return { loading, success, fail }
}
